import { SHOW_LOADER } from './../action_types';

export const showLoader = bool => {
    return {
        type: SHOW_LOADER,
        payload: bool
    }
}